import {
  type Motif,
  defaultMotif,
  FontFamily,
  m,
  mergeMotifs,
  MotifComponent,
  MotifScheme,
} from '@snapchat/snap-design-system-marketing';

/** Generated by figmaTokensImport on 2023-11-18T04:39:42.862Z. */
export const customBlueMotif: Motif = mergeMotifs(defaultMotif, {
  name: 'Blue',
  fontFamily: [FontFamily.GHOST_SANS],
  [MotifScheme.DEFAULT]: {
    name: 'Imported Deafult',
    legacyName: 'Yellow',
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-desktop-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-weight': 'Medium',
      '--hyperlink-desktop-font-weight': 'Medium',
      '--hyperlink-color': `${m('--action-hover-color')}`,
    },
    [MotifComponent.ROOT]: {
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--box-shadow-l': '0px 16px 32px 0 #000 12%',
      '--bg-color': m('--palette-blue-v100'),
      '--action-default-color': m('--neutral-v500'),
      '--action-hover-color': m('--neutral-v600'),
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-fg-color': m('--palette-blue-v50'),
      '--button-secondary-bg-color': m('--palette-blue-v50'),
      '--button-secondary-hover-bg-color': m('--palette-blue-v50'),
      '--button-secondary-border-color': m('--palette-blue-v50'),
      '--button-secondary-hover-border-color': m('--palette-blue-v50'),
      '--button-flat-fg-color': `${m('--fg-color')}`,
      '--button-border-radius': `${m('--border-radius-s')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-m)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {
      '--global-header-nav-screen-fg-color': m('--neutral-v650'),
    },
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': m('--neutral-v700'),
      '--block-title-color': m('--neutral-v700'),
      '--block-subtitle-color': m('--neutral-v700'),
    },
    [MotifComponent.TABS]: {},
    [MotifComponent.BREAK]: {},
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--fg-color')}`,
      '--accordion-divider-border-color': `${m('--fg-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--bg-color')}`,
      '--footer-divider-border-color': `${m('--fg-color')}`,
      '--footer-bar-bg-color': `${m('--bg-color')}`,
    },
    [MotifComponent.SUMMARY_CARD]: {
      '--summary-card-title-color': m('--neutral-v700'),
      '--summary-card-description-color': m('--neutral-v600'),
      '--summary-card-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FORM]: {
      '--form-input-bg-color': m('--palette-blue-v50'),
      '--form-input-border-radius': `${m('--border-radius-xl')}`,
      '--form-input-padding': 'var(--spacing-m) var(--spacing-l)',
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {
      '--footnote-fg-color': m('--neutral-v500'),
      '--footnote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--bg-color')}`,
      '--banner-fg-color': `${m('--fg-color')}`,
    },
    [MotifComponent.CONTENT]: {
      '--content-mobile-grid-gap': `${m('--spacing-l')}`,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': m('--palette-blue-v100'),
      '--mosaic-title-color': m('--palette-blue-v50'),
    },
    [MotifComponent.MEDIA]: {},
    [MotifComponent.SEARCH]: {},
    [MotifComponent.PAGINATION]: {},
    [MotifComponent.SIDE_NAVIGATION]: {},
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-bg-color': 'rgba(0,0,0,0.7)',
      '--modal-close-fg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-bg-color': m('--neutral-v700'),
      '--icon-button-hover-bg-color': m('--neutral-v600'),
      '--icon-button-disabled-bg-color': 'rgba(0,0,0,0)',
    },
  },
  [MotifScheme.SECONDARY]: {
    name: 'Imported secondary',
    legacyName: 'Black',
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-desktop-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-weight': 'Medium',
      '--hyperlink-desktop-font-weight': 'Medium',
      '--hyperlink-color': `${m('--action-hover-color')}`,
    },
    [MotifComponent.ROOT]: {
      '--box-shadow-s': '0px 4px 8px 0 rgba(0, 0, 0, 0.12)',
      '--box-shadow-m': '0px 8px 16px 0 rgba(0, 0, 0, 0.12)',
      '--border-radius-xs': '1px',
      '--border-radius-s': '4px',
      '--border-radius-m': '8px',
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--spacing-xxxs': '2px',
      '--spacing-xxs': '4px',
      '--spacing-xs': '8px',
      '--spacing-s': '12px',
      '--spacing-m': '16px',
      '--spacing-l': '24px',
      '--spacing-xl': '32px',
      '--spacing-xxl': '40px',
      '--spacing-xxxxl': '64px',
      '--box-shadow-l': '0px 16px 32px 0 #000 12%',
      '--fg-color': m('--palette-blue-v50'),
      '--action-default-color': m('--neutral-v500'),
      '--action-hover-color': m('--neutral-v600'),
      '--action-active-color': m('--neutral-v700'),
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-bg-color': m('--palette-blue-v100'),
      '--button-primary-hover-bg-color': m('--palette-blue-v100'),
      '--button-primary-border-color': m('--palette-blue-v100'),
      '--button-primary-hover-border-color': m('--palette-blue-v100'),
      '--button-secondary-bg-color': m('--palette-blue-v50'),
      '--button-secondary-hover-bg-color': m('--palette-blue-v50'),
      '--button-secondary-border-color': m('--palette-blue-v50'),
      '--button-secondary-hover-border-color': m('--palette-blue-v50'),
      '--button-flat-fg-color': m('--palette-blue-v50'),
      '--button-border-radius': `${m('--border-radius-s')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-m)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {
      '--global-header-nav-screen-fg-color': m('--neutral-v650'),
      '--global-header-fg-color': m('--neutral-v200'),
    },
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': m('--palette-blue-v50'),
      '--block-title-color': m('--palette-blue-v50'),
      '--block-subtitle-color': m('--palette-blue-v50'),
    },
    [MotifComponent.TABS]: {
      '--tabs-underline-color': m('--neutral-v600'),
    },
    [MotifComponent.BREAK]: {},
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--fg-color')}`,
      '--accordion-divider-border-color': `${m('--fg-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--bg-color')}`,
      '--footer-divider-border-color': `${m('--fg-color')}`,
      '--footer-bar-bg-color': `${m('--bg-color')}`,
    },
    [MotifComponent.SUMMARY_CARD]: {
      '--summary-card-title-color': m('--neutral-v700'),
      '--summary-card-description-color': m('--neutral-v600'),
      '--summary-card-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FORM]: {
      '--form-input-bg-color': m('--palette-blue-v50'),
      '--form-input-border-radius': `${m('--border-radius-xl')}`,
      '--form-input-padding': 'var(--spacing-m) var(--spacing-l)',
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {
      '--footnote-fg-color': m('--neutral-v500'),
      '--footnote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': m('--neutral-v600'),
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--bg-color')}`,
      '--banner-fg-color': `${m('--fg-color')}`,
    },
    [MotifComponent.CONTENT]: {
      '--content-mobile-grid-gap': `${m('--spacing-l')}`,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': m('--palette-blue-v100'),
      '--mosaic-title-color': m('--palette-blue-v50'),
    },
    [MotifComponent.MEDIA]: {},
    [MotifComponent.SEARCH]: {
      '--search-no-results-bg-color': m('--neutral-v150'),
      '--search-no-results-fg-color': m('--neutral-v650'),
    },
    [MotifComponent.PAGINATION]: {
      '--pagination-text-active-color': m('--palette-blue-v50'),
      '--pagination-text-color': m('--neutral-v400'),
      '--pagination-text-hover-color': m('--neutral-v300'),
    },
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-bg-color': 'rgba(0,0,0,0.7)',
      '--modal-close-bg-color': m('--neutral-v700'),
      '--modal-close-fg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-hover-bg-color': m('--neutral-v200'),
      '--icon-button-disabled-bg-color': m('--neutral-v500'),
      '--icon-button-border-color': m('--neutral-v0'),
      '--icon-button-fg-color': m('--neutral-v700'),
      '--icon-button-disabled-fg-color': m('--neutral-v400'),
    },
  },
  [MotifScheme.TERTIARY]: {
    name: 'Imported tertiary',
    legacyName: 'White',
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-desktop-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-weight': 'Medium',
      '--hyperlink-desktop-font-weight': 'Medium',
      '--hyperlink-color': `${m('--action-hover-color')}`,
    },
    [MotifComponent.ROOT]: {
      '--box-shadow-s': '0px 4px 8px 0 rgba(0, 0, 0, 0.12)',
      '--box-shadow-m': '0px 8px 16px 0 rgba(0, 0, 0, 0.12)',
      '--border-radius-xs': '1px',
      '--border-radius-s': '4px',
      '--border-radius-m': '8px',
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--spacing-xxxs': '2px',
      '--spacing-xxs': '4px',
      '--spacing-xs': '8px',
      '--spacing-s': '12px',
      '--spacing-m': '16px',
      '--spacing-l': '24px',
      '--spacing-xl': '32px',
      '--spacing-xxl': '40px',
      '--spacing-xxxxl': '64px',
      '--box-shadow-l': '0px 16px 32px 0 #000 12%',
      '--bg-color': m('--palette-blue-v50'),
      '--action-default-color': m('--neutral-v500'),
      '--action-hover-color': m('--neutral-v600'),
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-bg-color': m('--palette-blue-v100'),
      '--button-primary-hover-bg-color': m('--palette-blue-v100'),
      '--button-primary-border-color': m('--palette-blue-v100'),
      '--button-primary-hover-border-color': m('--palette-blue-v100'),
      '--button-secondary-fg-color': m('--palette-blue-v50'),
      '--button-border-radius': `${m('--border-radius-s')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-m)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {
      '--global-header-nav-screen-bg-color': m('--palette-blue-v50'),
      '--global-header-nav-screen-fg-color': m('--neutral-v650'),
      '--global-header-nav-screen-global-links-bg-color': m('--palette-blue-v50'),
      '--global-header-fg-color': m('--neutral-v650'),
    },
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': m('--neutral-v700'),
      '--block-title-color': m('--neutral-v700'),
      '--block-subtitle-color': m('--neutral-v700'),
    },
    [MotifComponent.TABS]: {},
    [MotifComponent.BREAK]: {},
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--fg-color')}`,
      '--accordion-divider-border-color': `${m('--fg-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--bg-color')}`,
    },
    [MotifComponent.SUMMARY_CARD]: {
      '--summary-card-title-color': m('--neutral-v700'),
      '--summary-card-description-color': m('--neutral-v600'),
      '--summary-card-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FORM]: {
      '--form-input-bg-color': m('--palette-blue-v50'),
      '--form-input-border-radius': `${m('--border-radius-xl')}`,
      '--form-input-padding': 'var(--spacing-m) var(--spacing-l)',
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {
      '--footnote-fg-color': m('--neutral-v500'),
      '--footnote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--bg-color')}`,
      '--banner-fg-color': `${m('--fg-color')}`,
    },
    [MotifComponent.CONTENT]: {
      '--content-mobile-grid-gap': `${m('--spacing-l')}`,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': m('--palette-blue-v100'),
      '--mosaic-title-color': m('--palette-blue-v50'),
    },
    [MotifComponent.MEDIA]: {},
    [MotifComponent.SEARCH]: {
      '--search-no-results-bg-color': m('--neutral-v150'),
      '--search-no-results-fg-color': m('--neutral-v650'),
    },
    [MotifComponent.PAGINATION]: {},
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-bg-color': 'rgba(0,0,0,0.7)',
      '--modal-close-bg-color': m('--neutral-v700'),
      '--modal-close-fg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-bg-color': m('--neutral-v700'),
      '--icon-button-hover-bg-color': m('--neutral-v600'),
      '--icon-button-disabled-bg-color': 'rgba(0,0,0,0)',
    },
  },
  [MotifScheme.QUATERNARY]: {
    name: 'Imported quaternary',
    legacyName: 'Gray',
    [MotifComponent.HYPERLINK]: {
      '--hyperlink-desktop-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-text-decoration': 'underline',
      '--hyperlink-mobile-font-weight': 'Medium',
      '--hyperlink-desktop-font-weight': 'Medium',
      '--hyperlink-color': `${m('--action-hover-color')}`,
    },
    [MotifComponent.ROOT]: {
      '--box-shadow-s': '0px 4px 8px 0 rgba(0, 0, 0, 0.12)',
      '--box-shadow-m': '0px 8px 16px 0 rgba(0, 0, 0, 0.12)',
      '--border-radius-xs': '1px',
      '--border-radius-s': '4px',
      '--border-radius-m': '8px',
      '--border-radius-l': '12px',
      '--border-radius-xl': '16px',
      '--spacing-xxxs': '2px',
      '--spacing-xxs': '4px',
      '--spacing-xs': '8px',
      '--spacing-s': '12px',
      '--spacing-m': '16px',
      '--spacing-l': '24px',
      '--spacing-xl': '32px',
      '--spacing-xxl': '40px',
      '--spacing-xxxxl': '64px',
      '--box-shadow-l': '0px 16px 32px 0 #000 12%',
      '--action-default-color': m('--neutral-v500'),
      '--action-hover-color': m('--neutral-v600'),
    },
    [MotifComponent.BUTTON]: {
      '--button-primary-bg-color': m('--palette-blue-v100'),
      '--button-primary-hover-bg-color': m('--palette-blue-v100'),
      '--button-primary-border-color': m('--palette-blue-v100'),
      '--button-primary-hover-border-color': m('--palette-blue-v100'),
      '--button-secondary-bg-color': m('--palette-blue-v50'),
      '--button-secondary-hover-bg-color': m('--palette-blue-v50'),
      '--button-secondary-border-color': m('--palette-blue-v50'),
      '--button-secondary-hover-border-color': m('--palette-blue-v50'),
      '--button-border-radius': `${m('--border-radius-s')}`,
      '--button-hover-shadow': `${m('--box-shadow-l')}`,
      '--button-regular-padding': 'var(--spacing-s) var(--spacing-m)',
      '--button-compact-padding': 'var(--spacing-xs) var(--spacing-m)',
    },
    [MotifComponent.HEADER]: {
      '--global-header-nav-screen-bg-color': m('--palette-blue-v50'),
      '--global-header-nav-screen-fg-color': m('--neutral-v650'),
      '--global-header-nav-screen-global-links-bg-color': m('--palette-blue-v50'),
      '--global-header-fg-color': m('--neutral-v650'),
    },
    [MotifComponent.BLOCK]: {
      '--block-eyebrow-color': m('--palette-blue-v200'),
      '--block-title-color': m('--palette-blue-v200'),
      '--block-subtitle-color': m('--neutral-v700'),
    },
    [MotifComponent.TABS]: {},
    [MotifComponent.BREAK]: {},
    [MotifComponent.ACCORDION]: {
      '--accordion-header-color': `${m('--fg-color')}`,
      '--accordion-divider-border-color': `${m('--fg-color')}`,
    },
    [MotifComponent.QUOTE]: {
      '--quote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FOOTER]: {
      '--footer-bg-color': `${m('--bg-color')}`,
      '--footer-bar-bg-color': `${m('--bg-color')}`,
    },
    [MotifComponent.SUMMARY_CARD]: {
      '--summary-card-title-color': m('--neutral-v700'),
      '--summary-card-description-color': m('--neutral-v600'),
      '--summary-card-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.FORM]: {
      '--form-input-bg-color': m('--palette-blue-v50'),
      '--form-input-border-radius': `${m('--border-radius-xl')}`,
      '--form-input-padding': 'var(--spacing-m) var(--spacing-l)',
      '--form-grid-gap': `${m('--spacing-m')}`,
    },
    [MotifComponent.FOOTNOTE]: {
      '--footnote-fg-color': m('--neutral-v500'),
      '--footnote-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.DROPDOWN_MENU]: {
      '--dropdown-menu-bg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.BANNER]: {
      '--banner-bg-color': `${m('--bg-color')}`,
      '--banner-fg-color': `${m('--fg-color')}`,
    },
    [MotifComponent.CONTENT]: {
      '--content-mobile-grid-gap': `${m('--spacing-l')}`,
    },
    [MotifComponent.MOSAIC]: {
      '--mosaic-border-radius': '24px',
      '--mosaic-grid-gap': '32px',
      '--mosaic-highlight-color': m('--palette-blue-v100'),
      '--mosaic-title-color': m('--palette-blue-v50'),
    },
    [MotifComponent.MEDIA]: {},
    [MotifComponent.SEARCH]: {
      '--search-no-results-bg-color': m('--neutral-v150'),
      '--search-no-results-fg-color': m('--neutral-v650'),
    },
    [MotifComponent.PAGINATION]: {},
    [MotifComponent.SPINNER]: {
      '--spinner-fg-color': `${m('--button-primary-fg-color')}`,
    },
    [MotifComponent.MODAL]: {
      '--modal-bg-color': 'rgba(0,0,0,0.7)',
      '--modal-close-bg-color': m('--neutral-v700'),
      '--modal-close-fg-color': m('--palette-blue-v50'),
    },
    [MotifComponent.ICON_BUTTON]: {
      '--icon-button-bg-color': m('--neutral-v700'),
      '--icon-button-hover-bg-color': m('--neutral-v600'),
      '--icon-button-disabled-bg-color': 'rgba(0,0,0,0)',
    },
  },
});
